// assets
import {
    IconBuildingBank,
    IconHeartHandshake,
    IconTools,
    IconPigMoney,
    IconBuildingStore,
    IconBusinessplan,
    IconCash,
    IconMoneybag,
    IconReport,
    IconLuggage,
    IconBrandAirtable
} from '@tabler/icons';

// constant
const icons = {
    IconBuildingBank,
    IconHeartHandshake,
    IconTools,
    IconPigMoney,
    IconBusinessplan,
    IconCash,
    IconBuildingStore,
    IconMoneybag,
    IconReport,
    IconLuggage,
    IconBrandAirtable
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //
// const email = (localStorage.getItem('email_id') || '').trim().toLowerCase();
// const checkAgentEmail = email === 'sruthys240@gmail.com' || email === 'annikitthomas@gmail.com';
const CommonService = {
    id: 'CommonService',
    title: 'Common Service',
    type: 'collapse',
    icon: icons.IconBrandAirtable,
    children: [
        {
            id: 'icons7',
            title: 'Government Services',
            type: 'item',
            icon: icons.IconBuildingBank,
            url: '/common-service/government-services',
            breadcrumbs: true
            // children: [
            //     {
            //         id: 'tabler-icons4',
            //         title: 'Government Services',
            //         type: 'item',
            //         url: '/common-service/government-services',
            //         breadcrumbs: true
            //     }
            // ]
        },
        // {
        //     id: 'tabler-icons23',
        //     title: 'Insurance 1',
        //     icon: icons.IconHeartHandshake,
        //     type: 'item',
        //     url: '/common-service/insurance',
        //     breadcrumbs: false
        // },
        {
            id: 'insurancen001',
            title: 'Insurance',
            type: 'collapse',
            isNew: true,
            icon: icons.IconHeartHandshake,
            children: [
                {
                    id: 'insurancen002',
                    title: 'Create Lead',
                    type: 'item',
                    url: '/common-service/insurance2',
                    breadcrumbs: false
                },
                {
                    id: 'insurancen004',
                    title: 'List Applications',
                    type: 'item',
                    url: '/common-service/insurance-list',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'tabler-icons24',
            title: 'Helping Tools',
            icon: icons.IconTools,
            type: 'item',
            url: '/common-service/helpingtools'
            // target: '_blank' // Add this property to specify opening in a new tab
        },
        {
            id: 'marketplace001',
            title: 'Marketplace Services',
            icon: icons.IconBuildingStore,
            type: 'item',
            isNew: true,
            url: '/marketplace/services'
        },
        {
            id: 'cmsF',
            title: 'CMS Service',
            type: 'collapse',
            isNew: true,
            icon: icons.IconCash,
            children: [
                {
                    id: 'CMSService',
                    title: 'CMS Service',
                    type: 'item',
                    url: '/cmsF/landingPage',
                    breadcrumbs: false,
                    icon: icons.IconMoneybag
                },
                {
                    id: 'CMSServiceReport',
                    title: 'CMS Service Report',
                    type: 'item',
                    url: '/cmsF/cmsTransactionList',
                    breadcrumbs: false,
                    icon: icons.IconReport
                }
            ]
        },
        {
            id: 'Loan-section001',
            title: 'Loans',
            type: 'collapse',
            isNew: true,
            icon: icons.IconPigMoney,
            children: [
                {
                    id: 'LoanFrom001',
                    title: 'Business Loan',
                    type: 'item',
                    url: '/loan/bussiness-loan',
                    breadcrumbs: false
                },
                {
                    id: 'LoanFrom002',
                    title: 'Personal Loan',
                    type: 'item',
                    url: '/loan/personal-loan',
                    breadcrumbs: false
                },
                {
                    id: 'ListLoans001',
                    title: 'Loan Applications',
                    type: 'item',
                    url: '/loan/loan-list',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'Goldloan001',
            title: 'Gold Loan',
            type: 'collapse',
            isNew: true,
            icon: icons.IconBusinessplan,
            children: [
                {
                    id: 'gold002',
                    title: 'Gold Loan',
                    type: 'item',
                    url: '/loan/gold-loan',
                    breadcrumbs: false
                },
                {
                    id: 'gold004',
                    title: 'List Applications',
                    type: 'item',
                    url: '/loan/gold-list',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'Travel001',
            title: 'Travel',
            type: 'collapse',
            isNew: true,
            icon: icons.IconLuggage,
            children: [
                {
                    id: 'travel002',
                    title: 'Travel',
                    type: 'item',
                    url: '/common-service/travel',
                    breadcrumbs: false
                },
                {
                    id: 'travel004',
                    title: 'Travel History',
                    type: 'item',
                    url: '/common-service/travel-list',
                    breadcrumbs: false
                }
            ]
        }
    ].filter(Boolean)
};

export default CommonService;
